import React, { useEffect, useRef } from "react";
import "./FeaturesAndFinishes.scss";
import FeaturesAndFinishesHero from "../FeaturesAndFinishesHero/FeaturesAndFinishesHero";
import FeaturesAndFinishesList from "../FeaturesAndFinishesList/FeaturesAndFinishesList";
import FeaturesAndFinishesRenderings from "../FeaturesAndFinishesRenderings/FeaturesAndFinishesRenderings";
import Cover from "../Cover/Cover";
import DragInfo from "../DragInfo/DragInfo";
import { useSelector } from "react-redux";
import MobileFooter from "../MobileFooter/MobileFooter";

function FeaturesAndFinishes() {
  const content = useSelector(
    (state) => state.content.pages.features_and_finishes,
  );
  const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);

  function scrollWheelTurned(e) {
    if (typeof underViewport.current !== "undefined")
      underViewport.current.scrollLeft += e.deltaY;
  }
  /*
    const [viewport] = useScrollBoost({
        direction: 'all',
        friction: 0.05,
        scrollMode: 'native',
        onClick: (state, event) => {
            if (state.isDragging) {
                event.preventDefault();
            }
        }
    });

    */
  const underViewport = useRef();
  const dragInfo = useRef();

  function hideDragInfo() {
    if (underViewport.current.scrollLeft > 40) {
      dragInfo.current.style.opacity = "0";
    } else {
      dragInfo.current.style.opacity = "1";
    }
  }

  useEffect(() => {
    window.addEventListener("wheel", scrollWheelTurned);

    return () => {
      window.removeEventListener("wheel", scrollWheelTurned);
    };
  });

  if (typeof content !== "undefined") {
    return (
      <div
        //ref={viewport}
        className="features-and-finishes-viewport"
        onScroll={hideDragInfo}
      >
        <div
          className={`features-and-finishes${isTouchScreen ? " touchscreen" : ""}`}
          ref={underViewport}
        >
          <Cover />
          <DragInfo reference={dragInfo} />
          {content.use_hero && (
            <FeaturesAndFinishesHero
              content={content.hero}
              download={content.download}
            />
          )}
          {content.use_renderings && (
            <FeaturesAndFinishesRenderings content={content.renderings} />
          )}
          {content.use_exterior && (
            <FeaturesAndFinishesList
              content={content.exterior}
              download={content.download}
              useDownload={content.use_download}
            />
          )}
          <MobileFooter showBelow={1300} />
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export default FeaturesAndFinishes;
